<div class="fundo">
  <img
    class="background__desktop"
    src="assets/images/backgrounds/background-novaSenha.png"
    alt=""
  />
  <div class="form__container">
    <form class="form" [formGroup]="membroForm">
      <div class="etapa" *ngIf="etapaAtual === ETAPA_METODO_ENVIO">
        <img
          class="logo"
          src="assets/images/icons/valida-dados-logo.png"
          alt="Logo de etapa validar dados"
        />
        <h1 class="titulo" *ngIf="!formatResumo">Uma pausa, é rápido!</h1>
        <h1 class="titulo" *ngIf="formatResumo">Espera só um minuto</h1>
        <p class="resumo">
          Para continuar participando do programa, precisamos validar sua conta.
        </p>
        <button
          class="btn validar"
          type="button"
          (click)="metodoEnvio(METODO_CELULAR)"
          [ngClass]="{ carregando: carregandoMetodoEnvioCelular }"
          *ngIf="this.membro.telefoneValidado !== true"
        >
          <i
            *ngIf="carregandoMetodoEnvioCelular"
            class="fa fa-spinner fa-spin"
          ></i>
          <img
            *ngIf="!carregandoMetodoEnvioCelular"
            src="assets/images/icons/validar-dados-celular.svg"
            alt="ìcone de validar dados celular"
          />
          Validar celular
        </button>
        <button
          class="btn validar"
          type="button"
          (click)="metodoEnvio(METODO_EMAIL)"
          [ngClass]="{ carregando: carregandoMetodoEnvioEmail }"
          *ngIf="this.membro.emailValidado !== true"
        >
          <i
            *ngIf="carregandoMetodoEnvioEmail"
            class="fa fa-spinner fa-spin"
          ></i>
          <img
            *ngIf="!carregandoMetodoEnvioEmail"
            src="assets/images/icons/validar-dados-email.svg"
            alt="ìcone de validar dados celular"
          />Validar e-mail
        </button>
        <button class="btn sair" type="button" (click)="cancelar()">
          Sair da conta
        </button>
      </div>
      <div class="etapa format" *ngIf="etapaAtual === ETAPA_ENVIO">
        <div class="voltar__container" (click)="voltar()">
          <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 2L2 8L8 14"
              stroke="#9A2225"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p>Voltar</p>
        </div>
        <h1 class="titulo">Confirme os seus dados</h1>
        <p class="resumo" [ngClass]="{ format_resumo_start: formatResumo }">
          Confirme seus dados e valide um meio de contato.
        </p>
        <div class="container__data__nasacimento" *ngIf="menorQueDataLimite">
          <h1 class="titulo2">Dados Pessoais</h1>
          <div class="input__container">
            <label class="label__input" for="dataNascimento"
              >Data de nascimento</label
            >
            <input
              class="input"
              [ngClass]="{ error: exibirDataVazio }"
              formControlName="dataNascimento"
              name="dataNascimento"
              id="dataNascimento"
              type="text"
              mask="00/00/0000"
              placeholder="00/00/0000"
            />
          </div>
          <small class="danger" *ngIf="membro && exibirDataVazio">
            Data máxima atingida
          </small>
        </div>
        <div class="container__contato">
          <h1 class="titulo2">Contato</h1>
          <div class="input__container" *ngIf="metodoAtual === METODO_EMAIL">
            <label class="label__input" for="email">E-mail</label>
            <input
              class="input"
              formControlName="email"
              name="email"
              id="email"
              type="email"
              placeholder="seuemail@exemplo.com"
              [ngClass]="{ error: membroForm.controls['email'].value === '' }"
            />
          </div>
          <small
            class="danger"
            *ngIf="membroForm.controls['email'].value === ''"
          >
            Campo obrigatório
          </small>
          <div class="input__container" *ngIf="metodoAtual === METODO_CELULAR">
            <label class="label__input" for="telefone">Celular</label>
            <input
              class="input"
              formControlName="telefone"
              name="telefone"
              id="telefone"
              type="text"
              inputmode="numeric"
              mask="(00)00000-0000"
              placeholder="(00)00000-0000"
              [ngClass]="{
                error: membroForm.controls['telefone'].value === ''
              }"
            />
          </div>
          <small
            class="danger"
            *ngIf="membroForm.controls['telefone'].value === ''"
          >
            Campo obrigatório
          </small>
        </div>
        <button
          class="btn validar enviar"
          type="button"
          (click)="enviarCodigo(metodoAtual)"
          [ngClass]="{
            carregando: enviarCodigoOtp,
            invalid:
              membroForm.controls['telefone'].value === '' ||
              membroForm.controls['email'].value === ''
          }"
        >
          <i *ngIf="enviarCodigoOtp" class="fa fa-spinner fa-spin"></i>
          <img
            *ngIf="!enviarCodigoOtp"
            src="assets/images/icons/validar-enviar-codigo.svg"
            alt="ìcone de validar dados celular"
          />
          Enviar código
        </button>
      </div>
      <div class="etapa format" *ngIf="etapaAtual === ETAPA_VALIDAR_CODIGO">
        <div class="voltar__container" (click)="voltar()">
          <svg
            width="10"
            height="16"
            viewBox="0 0 10 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 2L2 8L8 14"
              stroke="#9A2225"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <p>Voltar</p>
        </div>
        <h1 class="titulo">Código de validação</h1>
        <p class="resumo format_resumo">Insira aqui o código enviado para</p>
        <p class="resumo">
          {{
            metodoAtual === METODO_CELULAR
              ? membroForm.get("telefone").value
              : membroForm.get("email").value
          }}
        </p>
        <div class="container__otp">
          <ng-otp-input
            [config]="otpInputConfig"
            (onInputChange)="validarCodigo($event)"
          >
          </ng-otp-input>
        </div>
        <p class="reenviar" *ngIf="!habilitaReenvio">
          <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 20C16.1421 20 19.5 16.6421 19.5 12.5C19.5 8.35786 16.1421 5 12 5C7.85786 5 4.5 8.35786 4.5 12.5C4.5 16.6421 7.85786 20 12 20Z"
              stroke="#732029"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M12 9V13.5L15 15"
              stroke="#732029"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          {{ counter }}s
        </p>
        <button
          (click)="reenviarOTP()"
          class="button__reenviar"
          *ngIf="habilitaReenvio"
        >
          Reenviar código
        </button>
      </div>
      <div class="etapa" *ngIf="etapaAtual === ETAPA_FINAL">
        <img
          class="logo"
          src="assets/images/icons/valida-dados-logo.png"
          alt="Logo de etapa validar dados"
        />
        <h1 class="titulo">Tudo pronto!</h1>
        <p class="resumo">
          Seus dados foram confirmados e você pode continuar curtindo nosso
          programa!
        </p>
        <button
          class="btn validar"
          type="button"
          (click)="dadosValidadosSucesso()"
        >
          Entrar
        </button>
        <button
          class="btn sair"
          *ngIf="
            this.membro.emailValidado !== true ||
            this.membro.telefoneValidado !== true
          "
          type="button"
          (click)="outroCampo()"
        >
          Validar
          {{ this.membro.emailValidado === true ? "celular" : "e-mail" }} também
        </button>
      </div>
    </form>
  </div>
</div>
